module.exports = __webpack_public_path__ + "media/images/area/feature/prefecture/gunma_excellence/013-eff0cb1039d000b1dd1a22c6851ae9a9.jpg";